import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';

const ErrorWrapper = styled('div', {
  borderWidth: 20,
  borderStyle: 'solid',
  borderColor: '#BB3131',
  backgroundColor: '#000',
  zIndex: 999999,
  color: '#FFF',
  padding: '10px 20px',
});

const StyledMessage = styled('pre', {
  whiteSpace: 'pre-wrap',
  fontSize: 14,
  fontWeight: 600,
  letterSpacing: '0.2px',
  margin: '10px 0',
});

const StyledWrapper = styled('pre', {
  whiteSpace: 'pre-wrap',
  paddingLeft: 20,
});

const StyledCodeStack = styled('code', {
  fontSize: 16,
  fontFamily: 'monospace',
});

export const ErrorMessage = ({ className, styles, error, ...props }) => {
  return (
    <ErrorWrapper {...props}>
      <StyledMessage>{error.message}</StyledMessage>
      <StyledWrapper>
        <StyledCodeStack>{error.stack}</StyledCodeStack>
      </StyledWrapper>
    </ErrorWrapper>
  );
};

ErrorMessage.propTypes = {
  className: PropTypes.string,
  styles: PropTypes.shape({}),
  error: PropTypes.shape({
    message: PropTypes.string,
    stack: PropTypes.string,
  }).isRequired,
};

ErrorMessage.defaultProps = {
  className: null,
  styles: null,
};
